import { Resource } from '../../../http/resource/resource.model';
// tslint:disable: variable-name

export class Login extends Resource {
    // id is inherited from Resource
    person_id: number;
    applyment_id: number;
    session_id: string;
    lgpd_popup: any;
    selective_process_id: string;
    lgpdDataFromPopUp: any;
}
